import { NgModule } from '@angular/core';
import { LocationService } from './location.service';
import { LocationBackend } from './location.backend';

@NgModule({
  providers: [LocationService, LocationBackend],
})
export class LocationModule {}
